// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "page-profile" + "." + "fe20aa7f" + ".chunk.css";
};